import apiUrl from '../../../../constants'
import axios from 'axios'
import Paginate from 'vuejs-paginate'
import moment from 'moment'
import {
	Validator
} from 'vee-validate'
import CryptoJS from 'crypto-js';
import {
	BasicSelect
} from 'vue-search-select'
import VueElementLoading from 'vue-element-loading';

export default {
	name: 'creategroup',
	components: {
		Paginate,
		BasicSelect,
		VueElementLoading
	},
	data: function() {
		return {
			isLoading: false,
			locationList: [],
			locationItem: {
				value: "",
				text: ""
			},
			groupList: [],
			groupItem: {
				value: "",
				text: ""
			},
			groupData: [],
			selectedRow: [],
			groupRowWiseData: [],
			opened: [],
			checkedRow: [],
			hubLoading: '',
			groupLoading: '',
			location: '',
			group: '',
			row: '',
			modaldata: '',
			useremail: '',
			fullErrorMessage: '',
			activemodal: false
		}
	},

	created: function() {},
	computed: {},
	filters: {
		moment: function(date) {
			if (date == null || date == '')
				return '--'
			return moment(date).format('DD-MM-YYYY HH:MM:SS');
		}
	},
	mounted() {
		var userdetailEncrypt = window.localStorage.getItem('userdetail')
		var bytes = CryptoJS.AES.decrypt(userdetailEncrypt.toString(), 'Key');
		var plaintext = bytes.toString(CryptoJS.enc.Utf8);
		var userdetail = JSON.parse(plaintext)
		this.useremail = userdetail[0].email;
		this.getHubList()
		this.getGroupList()
	},
	methods: {
		getHubList() {
			this.hubLoading = 'Loading Hub...'
			this.input = ({})
			axios({
					method: 'POST',
					'url': apiUrl.api_url_hubops + 'expose/hubservicecenter/dropdwon/list',
					'data': this.input,
					headers: {
						'authorization': 'authkey xB84JJ89Hd25',
					}
				})
				.then(result => {
					this.hubLoading = ''
					var HubDetails = result.data.ResponseData
					for (var i = 0; i < HubDetails.length; i++) {
						this.locationList.push({
							"value": HubDetails[i].HubID,
							"text": HubDetails[i].HubName + '(' + HubDetails[i].HubID + ')',
						})
					}
				}, error => {
					console.error(error)
				})
		},
		getGroupList() {
			this.groupLoading = 'Loading Group...'
			axios({
					method: 'GET',
					url: apiUrl.api_url_hubops + 'getAllGroups',
					headers: {
						'Authorization': 'authkey xB84JJ89Hd25'
					}
				})
				.then(result => {
					this.groupLoading = ''
					if (result.data.ResultCode == 100) {
						var GroupDetails = result.data.ResponseData
						for (var i = 0; i < GroupDetails.length; i++) {
							this.groupList.push({
								"value": GroupDetails[i].groupid,
								"text": GroupDetails[i].groupname,
							})
						}
					} else {
						//this.$alertify.error(result.data.ReturnMessage)
						this.$alert(result.data.ReturnMessage, "", "error");
					}
				}, error => {
					console.error(error)
				})
		},
		selectedLocation(locationItem) {
			this.locationItem = locationItem
			this.location = locationItem.text
		},
		selectedGroup(groupItem) {
			this.groupItem = groupItem
			this.group = groupItem.text
		},
		getAllGroupData() {
			this.isLoading = true
			this.groupData = []
			this.opened = []
			if (this.location != "" && this.group != "") {
				axios({
						method: 'GET',
						//url: apiUrl.api_url_hubops + 'fetchConnectionsMappedToGroup?groupid=' + this.groupItem.value + '&hubid=' + this.locationItem.value,
						// HUB-8340: replaces fetchConnectionsMappedToGroup (destination hub + ismapped)
						url: apiUrl.api_url_hubops + 'groups/' + this.groupItem.value + '/connection-mappings?destinationHubId=' + this.locationItem.value,
						headers: {
							'Authorization': 'authkey xB84JJ89Hd25'
						}
					})
					.then(result => {
						this.isLoading = false
						if (result.data.ResultCode == 100) {
							this.groupData = result.data.ResponseData;
							this.selectedRow = this.groupData.filter(data => {
								if (data.ismapped == true) {
									return data
								}
							})
						} else {
							//this.$alertify.error(result.data.ReturnMessage)
							this.$alert(result.data.ReturnMessage, "", "error");
						}
					}, error => {
						this.isLoading = false
						console.error(error)
					})
			} else {
				this.isLoading = false
			}
		},
		openModal(row, ind) {
			this.row = row
			const index = this.opened.indexOf(row.connectiongroupmappingid);
			if (index > -1) {
				this.opened.splice(index, 1)
			} else {
				this.opened = [];
				this.opened.push(row.connectiongroupmappingid)
				this.groupRowWiseData = []
				this.isLoading = true
				axios({
						method: 'GET',
						url: apiUrl.api_url_hubops + 'getConnectionGroupLocationsByConnectionMappingId?connectionGroupMappingId=' + this.row.connectiongroupmappingid,
						headers: {
							'Authorization': 'authkey xB84JJ89Hd25'
						}
					})
					.then(result => {
						this.isLoading = false
						if (result.data.ResultCode == 100) {
							this.groupRowWiseData = result.data.ResponseData;
						} else {
							//  this.$alertify.error(result.data.ReturnMessage)
							this.$alert(result.data.ReturnMessage, "", "error");
						}
					}, error => {
						this.isLoading = false
						console.error(error)
					})
			}
		},
		closeModal() {
			this.opened = [];
		},
		openActiveModal(data) {
			this.activemodal = true
			this.modaldata = data
		},
		closeActiveModal() {
			this.activemodal = false
		},
		activeInactiveStatus() {
			var newactStatus = this.modaldata.isactive ? false : true
			var url = 'deAllocateconnectionGroupLocations'
			this.input = {
				connectionGroupMappingId: this.modaldata.connectiongroupmappingid,
				createdBy: this.modaldata.createdby,
				destinationHubId: this.modaldata.destinationhubid,
				groupId: this.modaldata.groupid,
				isActive: newactStatus
			}
			axios({
					method: 'PUT',
					'url': apiUrl.api_url_hubops + url,
					'data': this.input,
					headers: {
						'authorization': 'authkey xB84JJ89Hd25'
					}
				})
				.then((response) => {
					if (response.data.ResultCode == 100) {
						//this.$alertify.success(response.data.ReturnMessage)
						this.$alert(response.data.ReturnMessage, "", "success");
						this.getViewApi(this.modaldata.connectiongroupmappingid)
					} else {
						//this.$alertify.error(response.data.ReturnMessage)
						this.$alert(response.data.ReturnMessage, "", "error");
					}
				})
				.catch((httpException) => {
					console.error('exception is:::::::::', httpException)
				})
		},
		getViewApi(id) {
			this.groupRowWiseData = []
			this.isLoading = true
			axios({
					method: 'GET',
					url: apiUrl.api_url_hubops + 'getConnectionGroupLocationsByConnectionMappingId?connectionGroupMappingId=' + id,
					headers: {
						'Authorization': 'authkey xB84JJ89Hd25'
					}
				})
				.then(result => {
					this.isLoading = false
					if (result.data.ResultCode == 100) {
						this.groupRowWiseData = result.data.ResponseData;
					} else {
						//this.$alertify.error(result.data.ReturnMessage)
						this.$alert(result.data.ReturnMessage, "", "error");
					}
				}, error => {
					this.isLoading = false
					console.error(error)
				})
		},
		saveGroupConnectionData() {
			for (var i = 0; i < this.selectedRow.length; i++) {
				if (this.selectedRow[i].ismapped == false) {
					this.checkedRow.push(this.selectedRow[i].connectiongroupmappingid)
				} else {
					this.checkedRow = []
				}
			}
			if (this.checkedRow.length == 0) {
				this.fullErrorMessage = 'Please select connection'
				return false;
			} else {
				this.fullErrorMessage = ''
				this.input = {
					"groupid": this.groupItem.value,
					"destinationhubid": this.locationItem.value,
					"connectiongroupmappingids": this.checkedRow,
					"destinationhubname": this.locationItem.text.split('(')[0].trim(),
					"destinationhubcode": this.locationItem.text.split('(')[0].trim(),
					"lastmodifiedby": this.useremail
				};
				axios({
						method: 'POST',
						'url': apiUrl.api_url_hubops + 'mapLocationToGroup',
						'data': this.input,
						headers: {
							'authorization': 'authkey xB84JJ89Hd25'
						}
					})
					.then(result => {
						if (result.data.ResultCode == 100) {
							//this.$alertify.success(result.data.ReturnMessage)
							this.$alert(result.data.ReturnMessage, "", "success");
						} else {
							//this.$alertify.error(result.data.ReturnMessage);
							this.$alert(result.data.ReturnMessage, "", "error");
						}
					}, error => {
						console.error(error)
					})
			}
		},
		resetForm() {
			this.locationItem = {
				value: "",
				text: ""
			}
			this.groupItem = {
				value: "",
				text: ""
			}
			this.location = ""
			this.group = ""
			this.fullErrorMessage = ""
			this.groupData = []
			this.selectedRow = []
			this.checkedRow = []
			this.opened = []
			this.$validator.reset()
		},
		onSubmit: function() {
			this.$validator.validateAll().then(() => {
				console.log('form is valid')
			}).catch(() => {
				console.log('errors exist')
			});
		},

	}
}


// WEBPACK FOOTER //
// ./src/views/components/group/addlocationtogroup/addlocationtogroup_component.js